function ABPASSVHousingBoard() {
  return (
    <div>
      <div style={{ width: "100%", height: "100%" }}>
        <iframe
          src="/Post1.html" // your HTML file in public folder
          title="ABPASS Validaition"
          width="100%"
          height="900px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}

export default ABPASSVHousingBoard;
